// WHY: allow-list, not a delimiter block-list -- a block-list only catches the literal
// characters checked for, while percent-encoding (%3B), double-encoding, or Unicode
// normalization can still smuggle a blocked delimiter past a regex that never decodes input.
const SAFE_PHONE_PATTERN = /^[+\d ().-]+$/;
export function isSafePhoneValue(phone) {
    return SAFE_PHONE_PATTERN.test(phone);
}
//# sourceMappingURL=is-safe-phone-value.js.map